export default __webpack_public_path__ + "images/5D.27b6cba.png";